import { render, staticRenderFns } from "./PromoCodeInput.vue?vue&type=template&id=774c9ba3&"
import script from "./PromoCodeInputVue.ts?vue&type=script&lang=ts&"
export * from "./PromoCodeInputVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports